import React, { useEffect, useState } from 'react'

export default function StudentASRReaderWrapper({history, initialUserInteraction, getReader, config}) {

    useEffect(()=>{
        if(!initialUserInteraction){
            history.push('/student')
        }
    }, [])

    const asrModifiedConfig = {
        ...config,
        enableInterventions: false
    }

    if(!initialUserInteraction) return null

    const readerManagerProps = {
        asrStoryId: 'a8a3ad90-0784-11ed-8fdd-5d5c895b1cfa', 
        config: asrModifiedConfig 
    }

    return (
        <div className='ready-module-asr-check-reader-manager'>
            {getReader(readerManagerProps)}
        </div>
    )
}
